import { Inject } from 'inversify-props'
import { LojaServiceAdapter } from './adapter/LojaServiceAdapter'
import { FormLoja, Loja, ParametrosControlPay } from '@/models'

const ERRO_NA_REQUISICAO = 'Erro ao salvar a loja'

export class SaveLojaUseCase {
	@Inject('LojaServiceAdapter')
	private lojaService!: LojaServiceAdapter

	async save(loja: FormLoja): Promise<Loja> {
		if (loja.id) {
			const lojaResponse = await this.lojaService.update(loja)
			if (lojaResponse) {
				return lojaResponse
			}
			throw new Error(lojaResponse)
		} else {
			const lojaResponse = await this.lojaService.create(loja)
			if (lojaResponse) {
				return lojaResponse
			}
			throw new Error(lojaResponse)
		}
	}

	async changeLoja(loja: Partial<FormLoja>, rota: string): Promise<Loja> {
		try {
			const lojaResponse = await this.lojaService.changeLoja(loja, rota)
			if (lojaResponse) return lojaResponse
			throw new Error(lojaResponse)
		} catch (error) {
			throw new Error(`${ERRO_NA_REQUISICAO} ${error.message}`)
		}
	}

	async gravarParametrosControlPay(lojaId: string, gravarParametrosControlPay: ParametrosControlPay): Promise<ParametrosControlPay> {
		return this.lojaService.gravarParametrosControlPay(lojaId, gravarParametrosControlPay)
	}

	async vincularLojas(loja: Partial<FormLoja>): Promise<void> {
		return this.lojaService.vincularLojas(loja)
	}

	async desvincularLoja(lojaId: string, lojaDesvincular: string): Promise<void> {
		return this.lojaService.desvincularLoja(lojaId, lojaDesvincular)
	}
}
